import { useParams } from "react-router-dom";
import { useAuth } from "@/core/auth/hooks/useAuth";
import { useCurrentBusiness } from "@/features/business/hooks/useCurrentBusiness";
import { ErrorState } from "@/shared/components/ui/ErrorState";
import { LoadingSpinner } from "@/shared/components/ui/LoadingSpinner";
import { Page, PageContent } from "@/shared/components/ui/Page";
import { PageHeader, PageHeaderAction } from "@/shared/components/ui/PageHeader";
import { StripeSettings } from "../components/StripeSettings";
import { useStripeConnection } from "../hooks/stripeQueries";

export function StripePage() {
  const { user } = useAuth();
  const { business, businessId, loading } = useCurrentBusiness();
  const { locationId } = useParams();
  const owner = !!business && !!businessId && !!locationId && !!user && business.ownerId === user.id;
  const query = useStripeConnection(businessId, user?.id, owner);
  return (
    <Page>
      <PageHeader title="Stripe" actions={owner && (
        <PageHeaderAction onClick={() => void query.refetch()} disabled={query.isFetching}>
          {query.isFetching ? "Refreshing..." : "Refresh"}
        </PageHeaderAction>
      )} />
      <PageContent>
        {loading ? (
          <LoadingSpinner message="Loading business..." />
        ) : owner && business && businessId && locationId && user ? (
          <StripeSettings
            key={`${businessId}:${locationId}:${user.id}`}
            businessId={businessId}
            businessName={business.name}
            locationId={locationId}
            userId={user.id}
          />
        ) : (
          <ErrorState message={business ? "Only the business owner can manage Stripe." : "Select a business to manage Stripe."} />
        )}
      </PageContent>
    </Page>
  );
}
